import { useEffect, useState } from 'react';

const links = [
  { href: '#home', label: '首页' },
  { href: '#topics', label: '热门话题' },
  { href: '#categories', label: '内容分类' },
  { href: '#highlights', label: '心得精选' },
  { href: '#community', label: '互动口碑' },
  { href: '#guide', label: '新手指引' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 md:px-6 h-16" aria-label="主导航">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            goTo('#home');
          }}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-chat-voice-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            看料社
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(l.href);
                }}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#join"
            onClick={(e) => {
              e.preventDefault();
              goTo('#join');
            }}
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
          >
            我的主页
          </a>
          <a
            href="#join"
            onClick={(e) => {
              e.preventDefault();
              goTo('#join');
            }}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            加入交流
          </a>
        </div>

        <button
          type="button"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer lg:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <ul className="flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    goTo(l.href);
                  }}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100 transition-colors cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-3 flex flex-col gap-2 sm:flex-row">
            <a
              href="#join"
              onClick={(e) => {
                e.preventDefault();
                goTo('#join');
              }}
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-center text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              加入交流
            </a>
            <a
              href="#join"
              onClick={(e) => {
                e.preventDefault();
                goTo('#join');
              }}
              className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-center text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              我的主页
            </a>
          </div>
        </div>
      )}
    </header>
  );
}